<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="chap-003"><a id="page_9">
<div class="chap_debut"></div>
<h1 class="chap_n"><span><span class="mev3">  1  </span></span></h1>
<h1 class="chap_tit"><span>WHAT IS RELIGION?</span></h1>
<h1 class="chap_stit"><span>The Problem of Definition</span></h1>
<div class="dev">
<p class="txt_courant_ssalinea"><span class="let">B</span><i>ea and Thomas have just come from the first class in Professor Fesser’s course on world religions.</i></p>
<div class="tableau" id="tableau-001">
<div class="table-align">
<table border="0" cellpadding="3" cellspacing="0">
<colgroup>
<col width="25%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Well, that was a surprise!</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">To me too, frankly. I think I’m going to drop this course.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Oh. Apparently your surprise was the opposite of mine. I didn’t think I was going to stay, but now I think I am. I thought the professor would be vague, but he’s not. He made us <i>think</i>.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">You think he made us think just because he asked a question we couldn’t answer and then shot down all our answers and left us hanging?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Yes! That’s exactly what Socrates used to do. And it’s a lot harder than most people think it is. And more valuable.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">But it didn’t help us to understand the thing we all came there to understand.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">What thing is that?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_10"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant">The religions of the world. That’s the course title, after all.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">And that’s what the professor talked about. So what’s your complaint?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">He proved that we didn’t even know what the word <i>religion</i> meant. So we don’t even know what we mean when we call these things <i>religions</i>. If we can’t even define the most basic term in the course, why bother taking a course in it? It’s ridiculous. Throughout history we keep having arguments about religion, and we fight wars to the death about religion, but we don’t even know <i>what it is</i>, what we’re fighting about! It’s ridiculous.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">I quite agree that that’s ridiculous. So let’s make it less ridiculous.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">How?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Don’t you think we made any progress in doing that today?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">In understanding the religions of the world, the thing this course is supposed to be about? No! In understanding what <i>religion</i> means? No!</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Don’t you think it’s progress to understand that we don’t really understand what we thought we did understand?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I understand how that Socratic skepticism may be fun for <i>you</i>. You like to play those games.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">It’s not fun and games. It’s understanding. That’s what you’re paying big tuition bucks to this university for, isn’t it?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant"><i>You</i> are, maybe. You just love to tear ideas apart, like Socrates, don’t you?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">But the Socratic method isn’t “me versus you.” It’s <i>logic</i>.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant"><i>Your</i> logic, maybe.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_11"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant">No, no, there’s no such thing as “your logic” or anybody else’s logic. There’s just logic. Two and two still make four when it moves from one mind to another.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I know that. I just took a course in logic.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">What grade did you get in it?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">None of your business.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">That’s a pretty low grade—“none of your business.”</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">You have no way of knowing what grade I got.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Yes, I do. Nobody who gets an A ever labels it “none of your business.”</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">So you think I should have been <i>grateful</i> to the professor for undermining everything I thought I knew about what religion is?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Absolutely.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">For the same reason you should be grateful to anybody who cleans your kitchen before you cook a meal in it.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Oh. You mean the Socratic method is kind of like garbage collection?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Exactly.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Okay, but what meal can we cook up in a kitchen that’s empty of food as well as garbage? Because that’s the upshot of what the professor said: that we have no food in our mind’s kitchen; that all our ideas about what religion is, all the ideas that we thought were “food for thought,” are really only garbage. So we’re left with an empty kitchen.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">That empty kitchen is called “an open mind.” Haven’t you heard the news? For 2,400 years, ever since Socrates, that has proved to be the very best approach for everything you want to learn. You can’t put <a id="page_12">knowledge into a closed mind any more than you can put food into a closed mouth.</a></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">But what good is an open mouth or an open mind unless it finds some food for it to clamp down on and eat? What good is it to starve? The professor showed us that we had no logical answer to the most basic question of all about religion—the question of what it is, what the word means, how to define it, what its essential nature is. And if we can’t take that very first step, how can we take the second? <i>You</i> should understand that, Mister Logic.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Maybe we <i>can </i>take that first step. Are you <i>sure </i>we can’t? We won’t know until we try, will we? Do you want to give up after only one try?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Hmm . . . maybe you’ve got a point there, Thomas. Maybe I should stay, for one more class at least. Yeah, I think I’ll give the course one more chance. I didn’t learn anything valuable today, but I might next week.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Do you really think you didn’t learn anything valuable today? Don’t you think it’s valuable to learn that your kitchen is full of garbage, that your mind is full of ignorance and fallacies? Isn’t that progress?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I wouldn’t call it all garbage.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Oh? So you think you do know what religion is?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Well, yes, I do.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Even though you can’t define it?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Yes, even though I can’t define it. We know all sorts of things we can’t define.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Like what?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Like beauty, or love, or time. Can you define time, Thomas?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">I think so.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_13"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant">I’m waiting.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Okay, let’s say I answer “No, I can’t define time.” So what?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">But you know what it is, what it means, don’t you? In practice you know it, even though in theory you don’t. You use a watch, and you live by a schedule, don’t you?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Yes, but that’s different. Defining time is different from defining religion. There’s no argument that proves we <i>can’t </i>define time, it’s just very tricky to do it. But we can’t define religion. It’s just a vague feeling or superstition.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Oh, so now you <i>are </i>defining it. Can you prove <i>that</i> definition?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">That’s not a definition. It’s too general. It’s not specific enough for a definition. It doesn’t say what kind of vague feeling or superstition it is, what makes it a <i>religious </i>feeling or superstition.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">So take it back.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Okay, I do. But that’s what the professor proved: that we have to take back all our attempts to define religion. It looks like it can’t be defined.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I don’t think he proved <i>that</i> at all.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Of course he did, and very easily too. Didn’t you follow his logic? Shall we go over it again?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Yes, let’s. Because I care about religion. And I think <i>you</i>, of all people, might be able to help me, even though you <i>don’t</i> care about it as I do. Because you have a very logical mind.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Thank you. But I <i>do</i> care about avoiding the world’s number one superstition.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Why must everything be black or white for you?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_14"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant">Not everything. But this certainly is. Because if there isn’t any real object for religious belief, if there’s nothing real that’s religious, or Godlike, or superhuman, or supernatural, or whatever religion is about, then religion has got to be the world’s number one superstition or myth or illusion. Freud even calls it a collective hallucination.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Why did he call it a hallucination? Well, Freud’s analysis of religion is . . .</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">No, I’m not asking about Freud, I’m asking about you. Why do you say it has to be either/or, black or white? Why does religion have to be either true or a hallucination? If you live by a hallucination, you’re not just wrong, you’re nuts. Are you saying religious people are all nuts?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Did you ever see the old Jimmy Stewart movie <i>Harvey</i>?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Is that the one about the invisible rabbit?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Yeah. Harvey the invisible thirteen-foot rabbit. It was Jimmy’s best friend.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I’ve heard of it.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">But Jimmy wasn’t four years old, he was forty. So if he really believed in Harvey, he’s nuts. It’s not only superstition and illusion, it’s insanity.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Of course. If he really believed it and it’s not there.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">But God is just a big Harvey! So to believe in God, or Nirvana, or Brahman, or Allah—whatever the indefinable religious thing is—that’s at least as crazy as believing in Harvey. More so, even, because God is even bigger and more important to a believer than Harvey was to Jimmy Stewart.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">No, that’s a bad analogy.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_15"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant">Why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">It isn’t crazy to believe in God.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Why not?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Because you can’t <i>know</i> that there is no God.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">But you can’t know for sure that there is no Harvey either! You can’t know there are no little green men from flying saucers out there somewhere hiding behind an invisibility shield. But you can’t know that there are either. So what makes more sense: to believe or not to believe in your big Harvey?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I have good reasons to believe in God.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Are they better than Jimmy’s reasons for believing in Harvey?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">You bet they are.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">And I also bet you can guess what my next question is going to be.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">I won’t fall for your strategy, Thomas. We’re not arguing about God’s existence yet. We’re trying to define religion before we argue about it. That’s logical, isn’t it?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Yes.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">And that’s what the class was about today.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">Because the professor is a logical man.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">That he is.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">That’s why he takes one question at a time.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">And he’s right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">So let’s get back to his first question. Let’s go over the professor’s argument again. Maybe we can find a weak point. Maybe we <i>can </i>define religion after all.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Good for you, Bea. You’re starting to think logically now.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">What are you, my professor?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Sort of. I’ll be yours if you’ll be mine. Deal?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_16"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant">Deal.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Let’s see, then, what was his argument? He started with the basic logical rule about definitions: that a definition has to be “coextensive” with the term defined, neither broader nor narrower. Because it has to cover <i>only</i> the thing defined, not other things too (that would make it too broad), but it has to cover <i>all</i> the examples of the thing defined, not just some of them (that would make it too narrow). Is there anything wrong with that principle?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant">No.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">And then he asked us for a definition of <i>religion</i> that would obey that rule and not be either too broad or too narrow. It would be too broad if it covered some things that <i>weren’t</i> religions as well as things that were; and it would be too narrow if it covered only some of the things we call religions but not all of them. Okay so far?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And you came up with the first attempt, remember?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes. I said <i>religion</i> meant worshiping some kind of god or gods. And he said that was too narrow because it didn’t cover Buddhism, Taoism, and Confucianism, which don’t usually have any gods.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And everybody acknowledges that those are religions.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And therefore religion can’t be defined as worshiping gods. Did you follow that logic?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes. And then nobody else dared to give another answer, so I tried again. I said religion was the deepest concern of the human heart. And the professor knocked that down too.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_17"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">Do you remember why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I thought he’d say something about the “heart” being indefinable, or “deepest” being only a metaphor, or “concern” being ambiguous . . .</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Which he certainly could have done!</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But all he said was that my definition was too broad. He said it covered so many other things that nobody classifies as religions—like sex and surfing and family, and nonreligious philosophies like Marxism and Stoicism and Epicureanism.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So what’s your complaint now?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That he didn’t answer his own question, he just showed us that we couldn’t answer it.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Do you know why he did that?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, do you?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, let’s figure it out logically.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">How?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, either he knows the answer or he doesn’t, right?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That’s logical.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And if he doesn’t know, he can’t tell us.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But in that case, why is he teaching this course?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Maybe he wants to learn.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Then he should be paying <i>us </i>tuition. And if he <i>does</i> know, why do you think he wouldn’t tell us?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Maybe he wants us to figure it out for ourselves.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">See? You did learn something after all.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Okay, but if that’s all I’m going to learn—well, I’m not going to pay good tuition money for that.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Who said that was all you’re going to learn? Why do you think there are more classes coming?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_18"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">Okay, maybe we’ll learn a lot in those other classes. But if that’s all we can learn about <i>this</i> question, about the definition of <i>religion</i>, then that’s a bummer.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Because now we have to give up on that question. We can’t define <i>religion</i>. And then how do we learn about religions in the rest of the course without even knowing what <i>religion</i> means?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Didn’t you implicitly answer that question yourself a minute ago by your analogy with time?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">How was that an answer?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Even if we can’t define it, we know what it is because we know how to use the word. And if we know what it is, even if we can’t define it, we can still learn a lot about it. For instance, we can progress from Newton to Einstein, from the fallacy of absolute time to the truth of the relativity of time, even though we don’t have a perfect definition of time itself. Did you disagree with that analogy?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No. In fact, I think it’s a pretty good one.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So we don’t have to start with a clear, logical definition of religion either. We want to end with it, but we don’t have to start with it. Even if we don’t have one, we don’t have to give up and become skeptics. So we can talk about religion even though we don’t really know exactly what we’re talking about.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I guess you’re right. But that’s a surprising thing for <i>you </i>to say. I know you, Thomas; you’re an inveterate skeptic.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, sure. But there are two kinds of skepticism: a lazy kind and a hard-working kind. The lazy kind wants to give up to save the wear and tear on the gray matter. <a id="page_19">That’s not me. The hard-working kind wants to do the opposite: to critique every idea and not <i>assume</i> it to be true. That’s me.</a></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Are you with me on this, Bea?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I guess so. But I wonder: can you question <i>everything</i>? Can you go anywhere without any assumptions at all?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think that’s the <i>only</i> way to go anywhere, to make progress: to treat every idea as false until it’s proved to be true. I think we should treat ideas in exactly the opposite way we treat people. We treat people as innocent until proven guilty. But the scientific method is to treat ideas as guilty until proven innocent.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So that’s your assumption: the scientific method.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, sure, but that’s not an assumption that some idea or other is <i>true</i>, that’s just a methodological assumption, a practical assumption. It’s a path, not a destination.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And what’s the justification for that path, that method?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I just told you: it’s practical. It works. It has worked remarkably well.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Where? In the sciences, right?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes. All of them.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But religion isn’t a science.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, and neither is astrology nor alchemy nor any other superstition, and neither is schizophrenia nor paranoia nor any other mental disorder. But we can still take a scientific attitude toward those things.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Now you’re <i>assuming</i> that religion is a mental disorder.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, I’m not. I’m only assuming that it <i>might </i>be. But I think you’re assuming that it’s not.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_20"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">No, I’m not just <i>assuming </i>that. I have good reasons for believing it.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You said that before. But you didn’t want to examine your reasons when I asked you what they were.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Later, maybe. But for now I just want to find out what religion is.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Fair enough. One game at a time.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Religion is more than a game. It’s the deepest thing in most people’s lives.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes, and that’s why it’s either the world’s biggest truth or the world’s biggest superstition. And even if we can’t define it, we can target it, as we can target an animal that we’re hunting, and maybe we can catch it. Are you game for hunting that game? Or are you afraid to explore the seas of your faith in the ship of reason?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I’m not afraid. Whether I stay in Professor Fesser’s course or not, I’ll stay in <i>our </i>course. I’ll talk with you about religion any time.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Thank you! Good for you, and good for me too.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And I think I’ll stay in the professor’s course too, even though I didn’t get what I wanted today. Because I learned something else from class today than the definition of religion.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You mean my Socratic “lesson one” about how little you really know?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh, that too, but I was thinking of something else, something more positive.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You mean the professor’s explanation of how this confused idea, the idea of “religion,” originated in history?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That’s a second point. But that’s not what I was thinking of either. But what was that point again?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_21"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">That the term <i>religion</i> arose in history only when different religions confronted each other and they needed some generic term, some X, when they started to argue that their X was a better X than the other X.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh, that was an enlightening point too. I never knew that before. Wasn’t that where the professor quoted from that guy who was the dean of the Harvard Divinity School some time in the last century? What was his name?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Wilfred Cantwell Smith. His book was <i>The Meaning and End of Religion</i>. Did you get his main point?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think so. It was that no religion in the world ever called itself a “religion” until it had to compete against other religions and needed some generic term for “that kind of thing” so that it could argue that it was a better “that kind of thing” than the other ones. So the term <i>religion</i> was imposed externally by historical circumstances instead of coming from inside the religion itself. And that was true for every religion, especially Christianity, which is the one he detailed the early history of.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I give you an A for your summary but not for your grammar.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Why?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You ended your last sentence with a preposition.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Ah, so ending a sentence with a preposition is something up with which you will not put?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You plagiarized that from somebody. Churchill, I think.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You can’t plagiarize a joke. They’re public property.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I accept your correction. So what’s the positive point you liked? Socratic critique was point one, but you said that was negative. And the historical origin of the term <a id="page_22"><i>religion</i> was point two, but you said you were thinking of another point. So what’s point three? And does it help us to define religion?</a></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, but it’s a kind of substitute for a definition. The professor said that even if we couldn’t <i>define </i>religion, deductively, we could still <i>describe </i>it, inductively, by observation of particular cases. He said that we can observe the same three dimensions of every religion in the world.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh, yeah. What did he call them again?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Creed, code, and cult. Or words, works, and worship. Theology, morality, and liturgy. Every religion tells you what to believe, how to live, and how to worship or pray or meditate or do some specifically religious practice. Because those express the three powers of the human soul, or the psyche, that nearly every psychologist from Plato to Freud seems to distinguish: the intellect, the moral will, and the heart, or the feelings, or the creative imagination, or whatever that third power is. I thought that three-part description was really useful. So I’m wondering: how do you want to argue about those three things?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">What makes you think I want to argue about them?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You want to argue about everything.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Thank you.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I didn’t mean it as a compliment. But how do you disagree with me about these three things?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think I would take Freud’s attitude toward all three of these functions of religion. Every religion says that it fulfills you in all three ways, but Freud showed that they <i>suppress</i> you in all three ways. They suppress the intellect, and they suppress the will, and they suppress <a id="page_23">the desires and the creative imagination. They limit you. They impose something on you. You let somebody else tell you what to believe and how to live and how to worship.</a></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That’s what Freud thought?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So that’s your assumption about all religions?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, that’s my conclusion about all religions.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Oh, so you’ve taken this class before? I didn’t know you were already an expert. So why are you here?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Touché, Bea. I accept your correction. It’s not my expert conclusion, just my so-far conclusion, my probable conclusion, my amateur conclusion.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But even if we disagree about whether religion suppresses you or fulfills you, we can still agree about what religion looks like, about those three dimensions of it, can’t we? They express three powers of the soul, or the psyche, or whatever you want to call it—the three human powers that no other animal has. And I was impressed by how the professor showed that by his examples from literature. Do you remember that part? He said that most long epics have three protagonists, and they always represent these three special powers. There’s a strong-willed leader who’s usually kind of egotistical, and there’s an intellectual, and there’s also a humble, intuitive, helpful, creative, practical guy. That’s Harry Potter, Hermione, and Ron. <i>The Lord of the Rings </i>has Aragorn, Gandalf, and Frodo. Star Trek has Captain Kirk, Mister Spock, and “Bones” McCoy. Dostoyevsky’s <i>Brothers Karamazov </i>has Dmitri, Ivan, and Alyosha. Even the Gospels have Jesus’ inner circle of Peter, John, and James.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_24"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">I know. You don’t have to go through all the examples.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I thought you’d like that point about the structure of religion mirroring the structure of the human psyche, because it’s empirical, it’s something we can all agree about because we can observe it, no matter what we believe about its value. It shows us something about how natural religion is, how it fits our human nature.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Maybe. But I don’t see how that pattern is going to help us decide whether religion is true or false. Hallucinations, too, have universal patterns.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That’s true.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">There’s a fourth point the professor made that I thought was useful.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">What point?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, the two of us disagree not only about whether religion is true or not, but also about how the different religions relate to each other. I’m what the professor called an “exclusivist.” I think all the religions of the world contradict each other. You seem to be what he called an “inclusivist.” You seem to believe them all. Isn’t that right?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes, deep down, at least, or at their center. I think they only <i>seem </i>to contradict each other when you stay on their peripheries. When you go down below the surface and you get to the deeper level, you see that they’re all really saying essentially the same thing in different words. They’re all different roads up the same mountain.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So you’re an inclusivist because you say that the religions include each other instead of logically excluding each other.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_25"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">And the professor, I think, is what he called a “pluralist.” He thinks religions are just different, and we can’t call them either exclusive or inclusive of each other. He suggested that they may be like different animal species and we don’t know them well enough to know whether they can mate or not.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So what is the connection between those three philosophical positions about religion—exclusivism, inclusivism, and pluralism—and the three dimensions of religion that we distinguished, creed and code and cult?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I thought I saw a connection there. Give me a minute to think about it. Oh, yeah. Here it is. If you look at their creeds, different religions seem to be exclusive of each other; but if you look at their moral codes, they’re inclusive of each other, or at least in massive agreement; and if you look at their cultic, religious practices, their forms of worship or prayer or contemplation or yoga, they’re just different, but not incompatible.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think you’re largely right there. That is a useful map of the religious landscape. But they’re still exclusive in their creeds.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But it shows that each of the three philosophies of comparative religion has some basis in truth. There’s truth everywhere. Truth is inclusive, because it’s much more mysterious than you can see with your black and white logic alone.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Is that your point? That we can just ignore logic?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, my point is that the three dimensions of religion help to solve the controversial problem of comparative religions, how the religions relate to each other. You <a id="page_26">may be right about creeds, but I’m right about codes and cults.</a></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So you win by a score of two to one? Is that your argument?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, I’m not saying it’s that simple.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But you are saying that codes and cults are more important than creeds.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I guess I am.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I disagree with that. I say the only honest reason for anyone ever to believe anything is that it’s true. That has to come first.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">For you, maybe.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">For you too, I think.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, Thomas, I don’t think most people are like you. I think for most people, goodness and morality and love are more important than truth. And happiness is too. Most people seek happiness all the time, but they don’t seek truth all the time.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And you’re like most people, right?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Right.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think I can prove you’re wrong about what most people put first, Bea. Answer me just one question: Do you believe in Santa Claus? Literally, I mean.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Of course not.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">But remember when you were three and it was December. Remember how well you behaved, how good you were and how moral? And remember how happy you were? So why don’t you believe in Santa Claus again? If you did, you could be so very good and so very happy, as you were when you were three.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That’s just silly, Thomas.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_27"><b>Thomas:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">Answer my silly question then: Why don’t you believe in Santa Claus?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Because I know Santa Claus isn’t real.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">My point exactly. You put truth first, even before goodness or happiness. It has to be <i>true</i> goodness and <i>true</i> happiness.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">All right, I’ll admit the importance of truth if you’ll admit the importance of goodness and love and happiness and beauty and joy and all those other things.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Of course I admit them. I just say they all have to be true.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I don’t disagree with that. But I think there are other ways to find the truth besides just logic. And I think religious experience is one of those ways.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Well, I’ve never had a religious experience, or a mystical experience, or whatever you’re talking about.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So how does that refute my “inclusivism”? It’s a fact that the moralities of all the world’s religions are essentially the same. They all have something like a Ten Commandments. They all teach unselfishness, and the Golden Rule, and justice, and love and mercy and compassion.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">That doesn’t prove inclusivism. Because inclusivism isn’t based just on comparing the obvious moral teachings. I’ve read inclusivist writers, like—what’s the guy’s name?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Frithjof Schuon, <i>The Transcendent Unity of Religions</i>.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant">Right. And most inclusivists argue as he does. Their inclusivism is based on the claim that all the religions are one in mystical experience. But that’s another thing entirely from morality.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_28"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">Well, even if you reject inclusivism, you don’t have to go to the other extreme and be an exclusivist. I’m surprised at you, Thomas—I thought science made you more open minded instead of narrow minded.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">I think you’re confusing two very different meanings of <i>exclusivism</i>, Bea: logical exclusivism versus salvation exclusivism. A logical exclusivism between different creeds doesn’t necessarily mean that everybody who believes a false creed goes to hell.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So why aren’t you a pluralist, then, like the professor?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Because pluralism sounds like the wrong kind of skepticism. It sounds like a cop-out.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So you’re critical of religion, <i>and</i> of inclusivism, <i>and</i> of pluralism.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">And you’re an exclusivist only because of logic.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Do you have to criticize every idea you hear except logic itself?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, I don’t have to, I choose to.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So that’s your assumption. Well, it’s not mine. I like to receive my data and let it sink in before I criticize it.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So do I.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">No, I think you only receive it with your senses and your logic, not your heart or your intuition.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">We have different methods, that’s true. Does that mean you don’t want to stay with me in our little two-person class outside of class?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Not at all. I think we can both learn a lot from each other.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">So you’ll stay?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Do you want me to?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Yes, I do.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><a id="page_29"><b>Bea:</b></a></p></td>
<td valign="top"><p class="txt_courant_justif">How much?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Very much.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Are you asking me to stay only with your mind?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">If I say my heart is in it, will you stay?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">If you say your heart <i>is</i> in it, will you be lying?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Are you playing games with me, Bea?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Why do you have to answer my question with another question?</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Thomas:</b></p></td>
<td valign="top"><p class="txt_courant_justif">Why <i>shouldn’t</i> I answer your question with another question? Answer me that!</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_droite"><b>Bea:</b></p></td>
<td valign="top"><p class="txt_courant_justif">You know, I think I’ll stay—maybe just to find the answer to <i>that</i> question.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</a></div><a id="page_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap1.vue?344b89aa